import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ReduxStateForm {
  email: string
  phone_number: string
}

const initialState: ReduxStateForm = {
  email: '',
  phone_number: '',
}

const phoneSlice = createSlice({
  name: 'FORM',
  initialState,
  extraReducers: {
    // [appTypes.RESET]: (state, action) => {
    //   return initialState
    // },
  },
  reducers: {
    setEmail(state, action: PayloadAction<string>) {
      state.email = action.payload
    },
    setPhoneNumber(state, action: PayloadAction<string>) {
      state.phone_number = action.payload
    },
  },
})

export const { actions, reducer } = phoneSlice
export default reducer
